// Components==============
import Button from 'components/UI/Button/Button';
import Textarea from 'components/UI/Form/Textarea';
import { AnimatePresence } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { AssessmentContext } from 'pages/Feedback/Feedback';
import React, { useContext, useState } from 'react';
import MemberBar from '../../Top/MemberBar/MemberBar';
import { AssessmentItemContext } from '../FeedbackItem';
import './ReviewTextArea.module.scss';
// =========================

export default function ReviewTextArea({
  item,
  value,
  setValue,
  handleSave,
  isExtern,
  type,
}: {
  item: string;
  value?: string;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  handleSave?: () => void;
  isExtern?: boolean;
  type?: 'good' | 'improvement';
}) {
  const lang = useRedux(
    (state) => state.localize?.languages.find((l) => l.active)?.code
  ) as 'nl' | 'en' | undefined;

  const [isEditing, setIsEditing] = useState(false);

  const { project } = useContext(AssessmentContext);

  const { secondAssessorAgrees, setSecondAssessorAgrees } = useContext(
    AssessmentItemContext
  );

  function onSave() {
    if (handleSave) {
      setIsEditing(false);
      return handleSave();
    }
  }

  if (!lang) return <></>;

  if (setValue)
    return (
      <div styleName={`wrapper ${handleSave ? 'with-save' : ''}`}>
        {!isExtern && (
          <div styleName="text">
            <h3>Valideer deze beoordeling</h3>
            <span>
              Ben je het eens met het oordeel van deze beoordelaar over de
              beroepsvaardigheid van deze student? Zo niet, geef dan aan waarom.
            </span>
            <div styleName="buttons">
              <Button
                onClick={() => {
                  setSecondAssessorAgrees(0);
                }}
                color={secondAssessorAgrees === 0 ? 'blue' : 'white'}
              >
                Oneens
              </Button>
              <Button
                onClick={() => {
                  setSecondAssessorAgrees(1);
                }}
                color={secondAssessorAgrees === 1 ? 'blue' : 'white'}
              >
                Eens
              </Button>
            </div>
          </div>
        )}
        {!!(secondAssessorAgrees === 0 || isExtern) && (
          <AnimatePresence>
            <Textarea
              name=""
              placeholder={
                isExtern && type === 'improvement'
                  ? 'Wat kan er beter?'
                  : isExtern && type === 'good'
                  ? 'Wat ging er goed?'
                  : ''
              }
              ext_formValue={value}
              ext_onChange={(e) => {
                setIsEditing(true);
                setValue(e.target.value);
              }}
              handleSave={onSave}
              color={isExtern ? 'grey' : 'white'}
              isEditing={handleSave ? isEditing : undefined}
              setIsEditing={handleSave ? setIsEditing : undefined}
            />
          </AnimatePresence>
        )}
      </div>
    );

  // if (!item.answer) return <></>;

  return (
    <div styleName="wrapper">
      <MemberBar
        user={project?.author}
        name={
          <h3 styleName="name">
            {project?.author?.first_name} {project?.author?.last_name}
          </h3>
        }
      />
      <p>{item}</p>
    </div>
  );
}
